import { PRODUCT_TEMPLATES } from 'shared/consts/productTemplates'

export const isRxTemplate = productTemplate =>
  [PRODUCT_TEMPLATES.OTX, PRODUCT_TEMPLATES.RX].includes(productTemplate)

export const hasRxBadge = (productTemplate, bonus) =>
  isRxTemplate(productTemplate) && bonus > 0

export const getBadgeColor = (productTemplate, bonus) =>
  hasRxBadge(productTemplate, bonus) ? 'rxgreen' : 'greyLight'
